import React from 'react'
import StructureLabel from 'LuxKit/Label/StructureLabel'

interface Props {
  className?: string
}

/**
 * Bundle discount badge for Maldives flight + hotel bundles.
 *
 * Displayed when a charter flight is purchased with a Maldives hotel,
 * indicating the 15% flight markup has been removed.
 */
function MaldivesBundleDiscountBadge({ className }: Props) {
  return (
    <StructureLabel
      variant="maldives-charter"
      className={className}
      data-testid="maldives-bundle-discount-badge"
    >
      Bundle discount
    </StructureLabel>
  )
}

export default MaldivesBundleDiscountBadge
